module.exports = __webpack_public_path__ + "static/media/beep.ede24ff0.mp3";